class Idp {

    constructor(name, uri) {
        Object.defineProperty(this, "_name", {
            value: name,
            writable: false,
            configurable: false
        });
        Object.defineProperty(this, "_uri", {
            value: uri,
            writable: false,
            configurable: false
        });
    }

    get name() {
        return this._name;
    }

    get uri() {
        return this._uri;
    }
}

export default Idp;